import SectionLabel from "../ui/SectionLabel";
import ScrollReveal from "../motion/ScrollReveal";
import StaggerContainer from "../motion/StaggerContainer";
import PretextReveal from "../motion/PretextReveal";

const steps = [
  {
    num: "01",
    title: "Discovery",
    desc: "We audit your business, map your goals, and define what to build — before a single line of code is written.",
  },
  {
    num: "02",
    title: "Strategy",
    desc: "A precise plan: timeline, tech stack, budget, and team — delivered upfront.",
  },
  {
    num: "03",
    title: "Build",
    desc: "Agile delivery in 2-week sprints. You see real progress every fortnight.",
  },
  {
    num: "04",
    title: "Launch",
    desc: "Staged deployment, full testing, documentation, and clean handover.",
  },
  {
    num: "05",
    title: "Retain",
    desc: "Monthly retainers for support, SEO, updates, and continuous improvement.",
  },
];

export default function ProcessSection() {
  return (
    <>
      <section className="owl-process-section" style={{ background: "#050505", padding: "100px 40px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <ScrollReveal direction="up">
            <SectionLabel text="THE PROCESS" />
          </ScrollReveal>

          <div style={{ margin: "28px 0 64px" }}>
            <PretextReveal
              mode="slide"
              as="div"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 300,
                fontSize: "clamp(36px, 4.5vw, 60px)",
                color: "#F8F4EC",
                lineHeight: 0.95,
              }}
              delay={0.1}
            >
              From first call
            </PretextReveal>
            <PretextReveal
              mode="slide"
              as="div"
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: "clamp(36px, 4.5vw, 60px)",
                color: "#D4A843",
                lineHeight: 1,
              }}
              delay={0.2}
            >
              to launch day.
            </PretextReveal>
          </div>

          <div style={{ position: "relative" }}>
            {/* Timeline connector line */}
            <div
              className="owl-process-line"
              style={{
                position: "absolute",
                top: 22,
                left: "10%",
                right: "10%",
                height: "0.5px",
                background: "rgba(212,168,67,0.3)",
                borderTop: "0.5px dashed #D4A843",
                zIndex: 0,
              }}
            />
            <StaggerContainer
              stagger={0.08}
              className="owl-process-grid"
              style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 0, position: "relative", zIndex: 1 }}
            >

            {steps.map((step) => (
              <div
                key={step.num}
                style={{ padding: "0 20px", position: "relative" }}
              >
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    border: "1.5px solid #D4A843",
                    background: "#050505",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                    position: "relative",
                    zIndex: 1,
                    fontFamily: "'Barlow Condensed', sans-serif",
                    fontWeight: 700,
                    fontSize: 12,
                    letterSpacing: "0.15em",
                    color: "#D4A843",
                    boxShadow: "0 0 12px rgba(212,168,67,0.15)",
                  }}
                >
                  {step.num}
                </div>

                <div
                  style={{
                    fontFamily: "'Bebas Neue', sans-serif",
                    fontSize: 84,
                    color: "#D4A843",
                    opacity: 0.05,
                    position: "absolute",
                    top: -24,
                    left: 12,
                    pointerEvents: "none",
                    lineHeight: 1,
                  }}
                >
                  {step.num}
                </div>

                <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 24, letterSpacing: "-0.02em", color: "#F8F4EC", marginBottom: 16 }}>
                  {step.title}
                </div>
                <PretextReveal mode="scroll-scrub" as="p" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 16, color: "#8B8378", lineHeight: 1.6 }}>
                  {step.desc}
                </PretextReveal>
              </div>
            ))}
            </StaggerContainer>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 640px) {
          .owl-process-section {
            padding: 64px clamp(20px, 5vw, 32px) !important;
          }
        }

        @media (max-width: 960px) {
          .owl-process-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
            padding-left: 20px;
          }

          .owl-process-grid > div {
            border-left: 1px solid rgba(212,168,67,0.3);
            padding-left: 32px !important;
            position: relative;
          }
          
          .owl-process-grid > div > div:first-child {
            position: absolute !important;
            left: -22px;
            top: 0;
            margin-bottom: 0 !important;
            background: #050505;
          }

          .owl-process-line {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
}
